import SvgGourdeIcon from "@Components/CustomIcon/SvgGourdeIcon"
import SvgLegume from "@Components/CustomIcon/SvgLegume"
import SvgPhysics from "@Components/CustomIcon/SvgPhysics"
import SvgPlatIcon from "@Components/CustomIcon/SvgPlatIcon"
import SvgPoidsIcon from "@Components/CustomIcon/SvgPoids"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { baseColors } from "@Constants/baseStyles"
import React from "react"
import { TouchableOpacity, View } from "react-native"

export const ToolboxMenuOfWeekCardItem = (props) => {
    return (
        <TouchableOpacity activeOpacity={0.8}>
            <View
                style={{
                    overflow: "hidden",
                    backgroundColor: baseColors.green.secondary,
                    height: 127,
                    borderRadius: 10
                }}
            >
                <View style={{ position: "absolute", top: -15, left: -10 }}>
                    <SvgPlatIcon height={98.78} width={83.6} />
                </View>
                <View style={{ flex: 1, justifyContent: "center", alignContent: "center", alignItems: "center" }}>
                    <BreeSerifText color={baseColors.white} fontSize={24}>
                        Menu de la semaine
                    </BreeSerifText>
                </View>

                <View style={{ position: "absolute", right: -5, bottom: -5 }}>
                    <SvgLegume height={70} width={70} />
                </View>
            </View>
        </TouchableOpacity>
    )
}
